<template>
  <div class="ak-sidebar" :class="[classes, bgColor]">
    <slot />
  </div>
</template>

<script>
import { computed, defineComponent } from 'vue'

export default defineComponent({
  /**
   * @type {String}
   * @description This is the name of the component this will also
   * be the tag name of the component to use in templates
   * @example
   * <ak-sidebar>Sidebar</ak-sidebar>
   */
  name: 'AkSidebar',

  /**
   * @type {Object}
   * @description A collection of properties that may be passed into
   * the component these will be bound to the component instance and
   * may be access in the template and component methods.
   */
  props: {
    /**
     * @type {Boolean}
     * @description Determines if the sidebar should be on the right
     * side
     */
    right: {
      type: Boolean,
      default: false,
    },

    /**
     * @type {String}
     * @description Determines the size of the sidebar
     */
    size: {
      type: String,
      default: null,
    },

    /**
     * @type {String}
     * @description Determines the bg of the sidebar
     */
    color: {
      type: String,
      default: null,
    },
  },

  /**
   * @param {Object} props - The properties of the component
   * @description Sets up the component and returns an object containing all of the
   * attributes for the component to use.
   */
  setup(props) {
    const classes = computed(() => {
      return {
        'ak-sidebar--right': props.right,
      }
    })

    const bgColor = computed(() => {
      switch (props.color) {
        case 'light':
          return 'bg-white'
        case 'dark':
          return 'bg-grey-dark'
        default:
          return 'bg-grey-lightest'
      }
    })

    return {
      classes,
      bgColor,
    }
  },
})
</script>
<style lang="scss">
@import '../../scss/_settings.scss';
.ak-sidebar {
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
</style>
